/*
 * @Description: Description
 * @Author: wning
 * @Date: 2022-12-12 17:05:51
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-05 14:58:39
 */
import { Http } from '@main/common/api'
// 列表
export const listUrl = '/upms/dict/item/page'

// 列表
export const apiPostDictItemPageApi = async (data) => Http.post('/upms/dict/item/page', data)
// 新增
export const apiPostDictItemAdd = async (data) => Http.post('/upms/dict/item/add', data)
export const apiPutDictItemUpdate = async (parmas) => Http.put('/upms/dict/item/update', parmas)
export const apiDeleteDictItemBathDelete = async (id) => Http.delete(`/upms/dict/item/batch/delete/${id}`)
export const apiGetDictItemFindById = async (id) => Http.get(`/upms/dict/item/findById/${id}`)

export const apiPutEnableDictItem = async (id) => Http.put(`/upms/dict/item/enable/${id}`)

export const apiPutDisableDictItem = async (id) => Http.put(`/upms/dict/item/disable/${id}`)

export const apiGetFindDictItem = async (dictType) => Http.get(`/upms/dict/item/findDictItems?dictType=${dictType}`)
